/* AXIS v2 brochure viewer (R-540). Richie's viewer logic, with ready-made page images in place of pdf.js:
   page-flip (St) turns the pages; each page's <img data-src> gets its src when the reader is within 2 spreads of
   it, so a phone loads a few hundred KB, not the 5 MB PDF. Search reads the page text asset once, on first use.
   Shoppable (option 3, 2026-10-23): the edition's map asset (data-map, made by scripts/axis-brochure-map.py) puts a
   button over each product; a tap shows the product's name, price and stock, fetched live from /products/<handle>.js,
   so nothing about price or stock is stored here. A product that is not published simply does not show.
   Phones (under 750 px) get the pages one under the other instead of the book, each spread split into its two printed
   pages, with tap to zoom; the contents row jumps to a section in either view. */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var money = function (cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: CUR, minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0); }
  };
  var cache = {};
  function product(h) {
    if (!cache[h]) cache[h] = fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cache[h];
  }
  function img(p, w) { var s = p.featured_image; if (!s) return ''; return s.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2').replace(/^\/\//, 'https://'); }
  function state(p) {
    var pre = (p.tags || []).some(function (t) { return String(t).toLowerCase() === 'preorder'; });
    if (!p.available) return ['out', 'Sold out'];
    return pre ? ['pre', 'Pre-order'] : ['in', 'Available'];
  }
  function priceHtml(p) {
    var from = p.price_varies ? 'From ' : '', close = p.compare_at_price && p.compare_at_price > p.price;
    return '<span class="axb-p__price">' + from + money(p.price) + (close ? ' <s>' + money(p.compare_at_price) + '</s>' : '') + '</span>' +
      (close ? '<span class="axb-p__tag axb-p__tag--close">Closeout</span>' : '');
  }

  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var q = function (s) { return root.querySelector(s); };
    // N counts the PDF's pages (spreads, 0-based "s" below); the book has a page element per PRINTED page: the two
    // covers whole, every spread between as its left and right halves (data-sp names the spread a page comes from)
    var bookEl = q('.axb-book'), N = +root.dataset.n, H = +root.dataset.h || 1132;
    var pages = [].slice.call(bookEl.querySelectorAll('.axb-page')), BN = pages.length, thumbs = [].slice.call(root.querySelectorAll('.axb-thumb'));
    var phone = window.matchMedia('(max-width: 749px)').matches;
    var map = null, flip = null, list = q('.axb-list'), pop = q('.axb-pop'), zoom = q('.axb-zoom');
    var srcs = [], srcs1 = [];
    pages.forEach(function (pg) { var s = +pg.dataset.sp, im = pg.querySelector('img'); if (im && srcs[s] == null) { srcs[s] = im.dataset.src; srcs1[s] = im.dataset.src1 || im.dataset.src; } });
    var spreadOf = function (i) { return pages[i] ? +pages[i].dataset.sp : 0; };
    var bookIdx = function (s) { for (var i = 0; i < BN; i++) if (+pages[i].dataset.sp === s) return i; return 0; };
    function load(i) { var im = pages[i] && pages[i].querySelector('img'); if (im && im.dataset.src && !im.getAttribute('src')) im.src = im.dataset.src; }
    function near(c) { for (var d = -2; d <= 4; d++) load(c + d); }

    /* ---- the product popover ---- */
    var popFor = null;
    function closePop() { pop.hidden = true; if (popFor) popFor.setAttribute('aria-expanded', 'false'); popFor = null; }
    function openPop(btn, spot) {
      if (popFor === btn) { closePop(); return; }
      closePop(); popFor = btn; btn.setAttribute('aria-expanded', 'true');
      var one = spot.i.length === 1;
      pop.innerHTML = '<div class="axb-pop__head"><p class="axb-pop__t">' + esc(spot.t) + '</p><button type="button" class="axb-pop__x" aria-label="Close">&times;</button></div>' +
        '<div class="axb-pop__body"><p class="axb-pop__wait">Checking price and stock&hellip;</p></div>';
      pop.className = 'axb-pop' + (one ? ' axb-pop--one' : '');
      pop.hidden = false; place(btn);
      Promise.all(spot.i.map(function (it) { return product(it[1]).then(function (p) { return p && { lbl: it[0], p: p }; }); })).then(function (rows) {
        if (popFor !== btn) return;
        rows = rows.filter(Boolean);
        var body = pop.querySelector('.axb-pop__body');
        if (!rows.length) { body.innerHTML = '<p class="axb-pop__wait">Not available online right now.</p>'; return; }
        if (one) {
          var p = rows[0].p, st = state(p);
          body.innerHTML = '<a class="axb-p1" href="' + esc(p.url) + '">' + (p.featured_image ? '<img src="' + esc(img(p, 300)) + '" alt="" width="150" height="150" loading="lazy">' : '') +
            '<span class="axb-p1__txt"><span class="axb-p__name">' + esc(p.title) + '</span>' + priceHtml(p) +
            '<span class="axb-p__st axb-p__st--' + st[0] + '">' + st[1] + '</span></span></a>' +
            '<a class="axb-pop__go" href="' + esc(p.url) + '">View product</a>';
        } else {
          body.innerHTML = '<ul class="axb-pl">' + rows.map(function (r) {
            var st = state(r.p);
            return '<li><a href="' + esc(r.p.url) + '"><span class="axb-pl__l">' + esc(r.lbl) + '</span><span class="axb-pl__n">' + esc(r.p.title) + '</span>' +
              '<span class="axb-pl__r">' + priceHtml(r.p) + '<span class="axb-p__st axb-p__st--' + st[0] + '">' + st[1] + '</span></span><span class="axb-pl__go" aria-hidden="true">View &rsaquo;</span></a></li>';
          }).join('') + '</ul>';
        }
        place(btn);
      });
    }
    function place(btn) {
      if (phone || window.innerWidth < 750) { pop.style.left = pop.style.top = ''; pop.classList.add('axb-pop--sheet'); return; }
      pop.classList.remove('axb-pop--sheet');
      var rr = root.getBoundingClientRect(), b = btn.getBoundingClientRect(), pw = pop.offsetWidth, ph = pop.offsetHeight;
      var x = Math.min(Math.max(8, b.left - rr.left + b.width / 2 - pw / 2), rr.width - pw - 8);
      var below = b.bottom - rr.top + 8, above = b.top - rr.top - ph - 8;
      var y = (below + ph < rr.height - 8 || above < 8) ? below : above;
      if (b.height > rr.height * .5) y = Math.max(8, Math.min(b.top - rr.top + 20, rr.height - ph - 8));
      pop.style.left = x + 'px'; pop.style.top = Math.max(8, y) + 'px';
    }
    pop.addEventListener('click', function (e) { if (e.target.closest('.axb-pop__x')) closePop(); });
    document.addEventListener('click', function (e) { if (!pop.hidden && !pop.contains(e.target) && !e.target.closest('.axb-spot')) closePop(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closePop(); if (!zoom.hidden) closeZoom(); } });

    /* ---- spots: x/y/w/h are fractions of the spread; a half page maps them into its own half ---- */
    function spotsHtml(pg, half) {
      // the red + marks one spot per product family on a spread, its largest (the photo, not the heading)
      var out = '', big = {};
      (pg.s || []).forEach(function (s, k) { var a = s.w * s.h; if (s.i.length > 1 && s.t.indexOf(':') < 0 && (!big[s.t] || a > big[s.t][1])) big[s.t] = [k, a]; });
      (pg.s || []).forEach(function (s, k) {
        var x = s.x, w = s.w;
        if (half) {
          var x0 = half === 'L' ? 0 : .5, x1 = x0 + .5, a = Math.max(x, x0), b = Math.min(x + w, x1);
          if (b - a < .012) return;
          x = (a - x0) * 2; w = (b - a) * 2;
        }
        var fam = big[s.t] && big[s.t][0] === k;
        out += '<button type="button" class="axb-spot' + (fam ? ' axb-spot--fam' : '') + '" data-p="' + (pg.n - 1) + '" data-k="' + k + '" aria-expanded="false" aria-label="' + esc(s.t) +
          '" title="' + esc(s.t) + '" style="left:' + (x * 100).toFixed(2) + '%;top:' + (s.y * 100).toFixed(2) + '%;width:' + (w * 100).toFixed(2) + '%;height:' + (s.h * 100).toFixed(2) + '%"></button>';
      });
      return out;
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.axb-spot'); if (!b || !map) return;
      e.preventDefault(); e.stopPropagation();
      openPop(b, map.pages[+b.dataset.p].s[+b.dataset.k]);
    }, true);

    /* ---- contents ---- */
    function buildToc() {
      var toc = q('.axb-toc'), secs = map.pages.filter(function (p) { return p.sec; });
      if (!toc || !secs.length) return;
      toc.innerHTML = secs.map(function (p) { return '<button type="button" data-i="' + (p.n - 1) + '">' + esc(p.sec) + '</button>'; }).join('');
      toc.hidden = false;
      toc.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) go(+b.dataset.i, true); });
    }

    /* ---- phones: the printed pages one under the other, tap to zoom ---- */
    function buildList() {
      var blank = (map && map.blank) || [], out = '', title = esc(root.dataset.title || 'Brochure');
      for (var i = 0; i < N; i++) {
        var pg = map ? map.pages[i] : { n: i + 1, s: [] }, full = i === 0 || i === N - 1;
        var img = function (pn) {
          return '<img loading="lazy" src="' + esc(srcs1[i]) + '"' + (full ? '' : ' srcset="' + esc(srcs1[i]) + ' 1600w, ' + esc(srcs[i]) + ' 3200w" sizes="200vw"') +
            ' alt="' + title + ', page ' + pn + '" width="' + (full ? 1600 : 3200) + '" height="' + H + '">';
        };
        if (full) {
          out += '<div class="axb-leaf axb-leaf--full" data-i="' + i + '" id="axb-leaf-' + i + '">' + img(i ? 2 * N - 2 : 1) + spotsHtml(pg) + '</div>';
          continue;
        }
        ['L', 'R'].forEach(function (h) {
          if (blank.indexOf((i + 1) + h) >= 0) return;
          out += '<div class="axb-leaf axb-leaf--' + h + '" data-i="' + i + '"' + (h === 'L' || blank.indexOf((i + 1) + 'L') >= 0 ? ' id="axb-leaf-' + i + '"' : '') +
            '>' + img(2 * i + (h === 'L' ? 0 : 1)) + spotsHtml(pg, h) + '</div>';
        });
      }
      list.innerHTML = out; list.hidden = false;
      list.addEventListener('click', function (e) {
        if (e.target.closest('.axb-spot')) return;
        var leaf = e.target.closest('.axb-leaf'); if (leaf) openZoom(+leaf.dataset.i, leaf.classList.contains('axb-leaf--R') ? 1 : 0);
      });
    }
    function openZoom(i, side) {
      zoom.innerHTML = '<button type="button" class="axb-zoom__x" aria-label="Close zoom">&times;</button><div class="axb-zoom__in"><img src="' + esc(srcs[i]) + '" alt=""></div>';
      zoom.hidden = false; document.documentElement.classList.add('axb-noscroll');
      var inner = zoom.querySelector('.axb-zoom__in'), im = inner.querySelector('img');
      var toSide = function () { inner.scrollLeft = side ? inner.scrollWidth : 0; };
      if (im.complete) requestAnimationFrame(toSide); else im.addEventListener('load', toSide);
    }
    function closeZoom() { zoom.hidden = true; zoom.innerHTML = ''; document.documentElement.classList.remove('axb-noscroll'); }
    zoom.addEventListener('click', function (e) { if (e.target.closest('.axb-zoom__x')) closeZoom(); });

    // go(s): to PDF page (spread) s, in either view
    function go(s, scroll) {
      s = Math.max(0, Math.min(N - 1, s)); closePop();
      if (flip) { turn(bookIdx(s)); if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      var leaf = root.querySelector('#axb-leaf-' + s) || root.querySelector('.axb-leaf[data-i="' + s + '"]');
      if (leaf) leaf.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    root._axbGo = go;

    /* ---- the book (desktop): printed pages, two at a time, the covers alone ---- */
    function turn(i) { flip.turnToPage(Math.max(0, Math.min(BN - 1, i))); update(); }
    function update() {
      if (!flip) return;
      var i = flip.getCurrentPageIndex(), portrait = flip.getOrientation() === 'portrait';
      var a = i, b = null;
      if (!portrait && i > 0 && i < BN - 1) { a = i % 2 ? i : i - 1; b = a + 1; }
      q('.axb-count').innerHTML = (b != null ? (a + 1) + '&ndash;' + (b + 1) : a + 1) + ' <span>of ' + BN + '</span>';
      q('.axb-range').value = a + 1;
      q('.axb-prev').disabled = i <= 0; q('.axb-next').disabled = (b != null ? b : a) >= BN - 1;
      var sp = spreadOf(a);
      thumbs.forEach(function (t, k) { t.classList.toggle('on', k === sp); });
      var on = thumbs[sp]; if (on && !q('.axb-thumbs').hidden) on.scrollIntoView({ block: 'nearest', inline: 'center' });
      near(a);
    }
    function startBook() {
      near(0);
      if (!window.St) { bookEl.classList.add('axb-noflip'); return; }
      // a printed page is A4 landscape (the spread image is two of them side by side); two pages show when the stage
      // is wider than 2 x minWidth, one at a time below that
      flip = new St.PageFlip(bookEl, { width: 800, height: Math.round(H / 2), size: 'stretch', minWidth: 300, maxWidth: 1100, minHeight: 212, maxHeight: 780,
        showCover: true, usePortrait: true, mobileScrollSupport: true, maxShadowOpacity: .35, flippingTime: 650, drawShadow: true, autoSize: true });
      flip.loadFromHTML(pages);
      flip.on('flip', function () { closePop(); update(); }); flip.on('changeOrientation', update); update();
      q('.axb-prev').addEventListener('click', function () { flip.flipPrev(); });
      q('.axb-next').addEventListener('click', function () { flip.flipNext(); });
      q('.axb-range').addEventListener('input', function (e) { turn(+e.target.value - 1); });
    }
    function addBookSpots() {
      pages.forEach(function (pg) {
        var s = map.pages[+pg.dataset.sp]; if (!s || !s.s || !s.s.length) return;
        var half = pg.classList.contains('axb-page--L') ? 'L' : pg.classList.contains('axb-page--R') ? 'R' : null;
        var d = document.createElement('div'); d.className = 'axb-spots'; d.innerHTML = spotsHtml(s, half); pg.appendChild(d);
      });
    }

    var mapReady = root.dataset.map ? fetch(root.dataset.map).then(function (r) { return r.json(); }).then(function (m) { map = m; }).catch(function () {}) : Promise.resolve();
    if (phone) {
      root.classList.add('axb-phone');
      mapReady.then(function () { buildList(); if (map) buildToc(); });
    } else {
      startBook();
      mapReady.then(function () { if (map) { addBookSpots(); buildToc(); } });
    }
    window.matchMedia('(max-width: 749px)').addEventListener('change', function (e) { if (e.matches !== phone) location.reload(); });

    q('.axb-thumbs').addEventListener('click', function (e) { var t = e.target.closest('.axb-thumb'); if (t) go(+t.dataset.i); });
    q('.axb-tgl').addEventListener('click', function () { var th = q('.axb-thumbs'); th.hidden = !th.hidden; this.setAttribute('aria-pressed', String(!th.hidden)); update(); });
    root.tabIndex = -1;
    root.addEventListener('keydown', function (e) {
      if (e.target.matches('input') || !flip) return;
      if (e.key === 'ArrowRight') { flip.flipNext(); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { flip.flipPrev(); e.preventDefault(); }
      if (e.key === 'Escape' && root.classList.contains('axb-full')) toggleFull();
    });
    function toggleFull() {
      var after = function () { closePop(); if (flip) setTimeout(function () { flip.update(); }, 60); };
      if (document.fullscreenElement === root) { document.exitFullscreen(); return; }
      if (root.requestFullscreen && !root.classList.contains('axb-full')) root.requestFullscreen().catch(function () { root.classList.toggle('axb-full'); after(); });
      else { root.classList.toggle('axb-full'); after(); }
    }
    q('.axb-fs').addEventListener('click', toggleFull);
    document.addEventListener('fullscreenchange', function () { root.classList.toggle('axb-full', document.fullscreenElement === root); closePop(); if (flip) setTimeout(function () { flip.update(); }, 80); });
    /* search */
    var texts = null, box = q('.axb-results'), timer;
    function getTexts() { if (texts || !root.dataset.text) return Promise.resolve(texts || []); return fetch(root.dataset.text).then(function (r) { return r.json(); }).then(function (t) { texts = t; return t; }).catch(function () { return []; }); }
    function search(v) {
      if (v.length < 2) { box.hidden = true; return; }
      getTexts().then(function (t) {
        var re = new RegExp(v.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i'), out = [];
        t.forEach(function (tx, i) { var m = tx && tx.match(re); if (!m) return;
          var st = Math.max(0, m.index - 50), snip = (st ? '...' : '') + tx.slice(st, m.index + v.length + 70) + '...';
          out.push('<button type="button" class="axb-res" data-i="' + i + '"><b>' + (i + 1) + '</b><span>' + esc(snip).replace(new RegExp(esc(v).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'ig'), function (x) { return '<mark>' + x + '</mark>'; }) + '</span></button>'); });
        box.innerHTML = out.length ? '<p>' + out.length + ' page' + (out.length > 1 ? 's' : '') + ' mention "' + esc(v) + '"</p>' + out.slice(0, 40).join('') : '<p>No pages mention "' + esc(v) + '".</p>';
        box.hidden = false;
      });
    }
    q('.axb-q').addEventListener('input', function (e) { clearTimeout(timer); var v = e.target.value.trim(); timer = setTimeout(function () { search(v); }, 180); });
    q('.axb-q').addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.target.value = ''; box.hidden = true; } if (e.key === 'Enter') { var f = box.querySelector('.axb-res'); if (f) f.click(); } });
    document.addEventListener('click', function (e) { if (!root.contains(e.target) || (!e.target.closest('.axb-results') && !e.target.closest('.axb-search'))) box.hidden = true; });
    box.addEventListener('click', function (e) { var r = e.target.closest('.axb-res'); if (r) { go(+r.dataset.i); box.hidden = true; } });
  }
  function boot() {
    document.querySelectorAll('.axb').forEach(init);
    // "page n" links in the brochure text below the viewer
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.axb-goto'); if (!a) return;
      var wrap = a.closest('.axb-wrap'), root = wrap && wrap.querySelector('.axb');
      if (root && root._axbGo) { e.preventDefault(); root._axbGo(+a.dataset.i, true); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
